import { agentsRoute } from '@townsquare/routes/agents';
import { rovoEntitlementResource } from '@townsquare/rovo/entitlement';

import { AgentsViewLoadable } from './components/AgentsView';

agentsRoute.component = AgentsViewLoadable;
agentsRoute.resources = [rovoEntitlementResource];
export const agentsRouterRoute = agentsRoute;
